


























import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({
  name: "AuditTabOfExternalMonthlyPlan",
  components: { AuditTabPane },
})
export default class AuditTabOfExternalMonthlyPlan extends Vue {
  get fetchData() {
    return api.externalMonthlyPlanService.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "externalMonthPlanDetail",
      params: {
        id: dto.id,
      },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
